import { Divider, Grid2, Skeleton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../../../../component/Breadcrumbs";
import AddUpdateNote from "../../../common-components/AddUpdateNote";
import CommonAccordion from "../../../common-components/CommonAccordion";
import DeleteNote from "../../../common-components/DeleteNote";
import Experience from "../jobs-candidate/components/Experience";
import MatchingSummary from "../jobs-candidate/components/MatchingSummary";
import Notes from "../jobs-candidate/components/Notes";
import StrengthWeak from "../jobs-candidate/components/StrengthWeak";
import Actions from "./components/Actions";
import CompareProfile from "./components/CompareProfile";
import { CustomDiv } from "../../../chat-bot/style";

function JigsawCandidateCompare() {
  const navigate = useNavigate();
  const param = useParams();
  const firstResumeId = param.firstResumeId;
  const secondResumeId = param.secondResumeId;
  const [pageLoader, setPageLoader] = useState(false);
  const [tableList, setTableList] = useState([]);
  const [listResumeData, setListResumeData] = useState([]);

  const [noteList, setNoteList] = useState([
    { note: "", interaction: "Email", added_by: "username" },
  ]);

  const [openNoteDialog, setOpenNoteDialog] = useState(false);
  const [deleteNoteDialogOpen, setDeleteNoteDialogOpen] = useState(false);
  const [noteId, setNoteId] = useState("");
  const [notesTableList, setNotesTableList] = useState([]);
  const [addNoteLoading, setAddNoteLoading] = useState(false);
  const [notesTableListLoading, setNotesTableListLoading] = useState(false);
  const [currentResumeId, setCurrentResumeId] = useState(null);

  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });

  // Mock data
  const mockCandidates = [
    {
      id: 1,
      name: "Candidate 1",
      experience: "3 years",
      skills: "JavaScript, React",
    },
    {
      id: 2,
      name: "Candidate 2",
      experience: "2 years",
      skills: "Node.js, Express",
    },
  ];

  const mockNotes = [
    {
      id: "1",
      note: "Note for Candidate 1",
      interaction: "Email",
      added_by: "user1",
      created_at: "2025-01-18",
    },
    {
      id: "2",
      note: "Note for Candidate 2",
      interaction: "Phone",
      added_by: "user2",
      created_at: "2025-01-17",
    },
  ];

  // Simulate fetching candidate comparison
  const fetchCandidateCompareList = () => {
    setTableList(mockCandidates);
    setPageLoader(false);
  };

  // Simulate fetching resume data
  const getlistResumeData = () => {
    setListResumeData(mockCandidates);
    fetchCandidateCompareList();
  };

  useEffect(() => {
    setPageLoader(true);
    getlistResumeData();
  }, [firstResumeId, secondResumeId]);

  const handleReplaceSecondaryId = (id) => {
    const currentUrl = window.location.pathname;
    const newUrl = currentUrl.replace(param.secondResumeId, id);
    navigate(newUrl); // Use React Router's `navigate` to update the route
  };

  const handleClickAddNote = (resumeId) => {
    setCurrentResumeId(resumeId);
    setOpenNoteDialog(true);
    setNoteId("");
    setNoteList([{ note: "", interaction: "Email", added_by: "username" }]);
  };

  const handleCloseNoteDialog = () => {
    setNoteId("");
    setOpenNoteDialog(false);
    setNoteList([{ note: "", interaction: "Email", added_by: "username" }]);
  };

  const handleDeleteNote = (row) => {
    setDeleteNoteDialogOpen(true);
    setNoteId(row?.id);
    setNoteList([
      {
        note: row?.note,
        interaction: row?.interaction,
        added_by: row?.added_by,
        created_at: row?.created_at,
      },
    ]);
  };

  const handleDeleteNoteDialogClose = () => {
    setDeleteNoteDialogOpen(false);
    setNoteId("");
    setNoteList([{ note: "", interaction: "Email", added_by: "username" }]);
  };

  const handleUpdateNote = (row) => {
    if (row?.id) {
      setNoteId(row?.id);
      setOpenNoteDialog(true);
      setNoteList([
        {
          note: row?.note,
          interaction: row?.interaction,
          added_by: row?.added_by,
        },
      ]);
    }
  };

  const handleCreateNote = async (resumeId) => {
    setAddNoteLoading(true);
    if (resumeId) {
      const payload = noteList;
      if (noteId) {
        setSnackbarState({
          open: true,
          severity: "success",
          message: "Note updated successfully",
        });
      } else {
        setSnackbarState({
          open: true,
          severity: "success",
          message: "Note added successfully",
        });
      }
      setAddNoteLoading(false);
      setOpenNoteDialog(false);
      setNoteList([{ note: "", interaction: "Email", added_by: "username" }]);
    }
  };

  const handleDeleteNoteById = (row) => {
    setSnackbarState({
      open: true,
      severity: "success",
      message: "Note deleted successfully",
    });
    setDeleteNoteDialogOpen(false);
    setNoteId("");
  };

  const fetchNotesTableList = () => {
    setNotesTableList(mockNotes);
  };

  useEffect(() => {
    fetchNotesTableList();
  }, [firstResumeId, secondResumeId]);

  const breadCrumbData = [
    { title: "Jigsaw", navigate: "/access-team-fit" },
    { title: "Leadership", navigate: -1 },
    { title: "Compare", active: true },
  ];

  const handleNoteTextChange = (index, e) => {
    const newNoteList = [...noteList];
    newNoteList[index].note = e.target.value;
    setNoteList(newNoteList);
  };

  return (
    <CustomDiv background="#F6F8FB">
      <CustomDiv
        border={"1px solid rgba(0, 0, 0, 0.12)"}
        background="#fff"
        borderRadius={"10px"}
        height={"fit-content"}
        padding={"1rem"}
        margin={"1.35rem 1rem 1.35rem 1.35rem"}
      >
        <Grid2 container spacing={3}>
          <Grid2 size={12}>
            <Breadcrumbs breadCrumbData={breadCrumbData} />
          </Grid2>
          {pageLoader ? (
            Array.from(new Array(20)).map((el, ind) => (
              <Grid2 item size={4} key={`key-${ind}`}>
                <Skeleton width={"100%"} height={100} />
              </Grid2>
            ))
          ) : (
            <>
              <Grid2 size={12}>
                <Grid2 container spacing={3}>
                  {/* {tableList?.map((item, index) => ( */}
                  <Grid2 size={12}>
                    <CompareProfile />
                  </Grid2>
                  {/* ))} */}
                </Grid2>
              </Grid2>

              <Grid2 size={12}>
                <CommonAccordion
                  title={"Overall"}
                  children={
                    <Grid2 container spacing={3}>
                      {tableList?.map((item, index) => (
                        <Grid2 size={6} key={index}>
                          <MatchingSummary />
                        </Grid2>
                      ))}
                    </Grid2>
                  }
                />
              </Grid2>

              <Grid2 size={12}>
                <CommonAccordion
                  title={"Strengths"}
                  children={
                    <Grid2 container spacing={3}>
                      {tableList?.map((item, index) => (
                        <Grid2 size={6} key={index}>
                          <StrengthWeak size={12} />
                        </Grid2>
                      ))}
                    </Grid2>
                  }
                />
              </Grid2>

              <Grid2 size={12}>
                <CommonAccordion
                  title={"Experience"}
                  children={
                    <Grid2 container spacing={3}>
                      {tableList?.map((item, index) => (
                        <Grid2 size={6} key={index}>
                          <Experience matchedData={item?.experience} />
                        </Grid2>
                      ))}
                    </Grid2>
                  }
                />
              </Grid2>

              {/* <Grid2 size={12}>
            <CommonAccordion
              title={"Notes"}
              children={
                <Grid2 container spacing={3}>
                  {notesTableList.map((item, index) => (
                    <Grid2 key={item.resumeId} size={6}>
                      <Notes
                        openNoteDialog={openNoteDialog}
                        deleteNoteDialogOpen={deleteNoteDialogOpen}
                        noteId={noteId}
                        handleClickAddNote={() =>
                          handleClickAddNote(item.resumeId)
                        }
                        handleCloseNoteDialog={handleCloseNoteDialog}
                        handleDeleteNote={handleDeleteNote}
                        handleDeleteNoteDialogClose={
                          handleDeleteNoteDialogClose
                        }
                        handleUpdateNote={handleUpdateNote}
                        notesTableList={item.notes}
                        notesTableListLoading={notesTableListLoading}
                      />
                    </Grid2>
                  ))}
                </Grid2>
              }
            />
          </Grid2> */}

              <Grid2 size={12}>
                <Divider />
              </Grid2>

              <Grid2 size={12}>
                <Grid2 container spacing={3}>
                  {tableList?.map((item, index) => (
                    <Grid2 size={6} key={index}>
                      <Actions matchedData={item} />
                    </Grid2>
                  ))}
                </Grid2>
              </Grid2>
            </>
          )}
          <DeleteNote
            deleteNoteDialogOpen={deleteNoteDialogOpen}
            handleDeleteNoteDialogClose={handleDeleteNoteDialogClose}
            noteList={noteList}
            handleDeleteNoteById={handleDeleteNoteById}
          />
          <AddUpdateNote
            openNoteDialog={openNoteDialog}
            handleCloseNoteDialog={handleCloseNoteDialog}
            id={noteId}
            handleCreateNote={() => handleCreateNote(currentResumeId)}
            noteList={noteList}
            handleNoteTextChange={handleNoteTextChange}
            addNoteLoading={addNoteLoading}
          />
        </Grid2>
      </CustomDiv>
    </CustomDiv>
  );
}

export default JigsawCandidateCompare;
